import Vue from 'vue'
import VueRouter from 'vue-router'
import $store from '@/store/index';

Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 在此处配置路由
const routes = [{
		path: '/',
		redirect: '/Home'
	},
	{
		path: '/',
		component: () => import('../views/Base.vue'),
		children: [{
				path: '/Home',
				component: () => import('../views/Home/Home.vue'),
				meta: {
					title:  $store.state.language == 'es-ES' ? 'Inicio' : $store.state.language == 'en-GB' ? 'Home' : '首页'
				}
			},
			{
				path: '/ConnectUs',
				component: () => import('../views/ConnectUs/ConnectUs.vue'),
				meta: {
					title: '联系我们'
				}
			},
			{
				path: '/Article',
				component: () => import('../views/Article/detail.vue'),
				meta: {
					title: '文章'
				}
			},
			{
				path: '/GoodsDetail',
				component: () => import('../views/Goods/detail.vue'),
				meta: {
					title:  $store.state.language == 'es-ES' ? 'Detalles de producto' : $store.state.language == 'en-GB' ? 'Goods details' : '商品详情'
				}
			},
			{
				path: '/Detail_Mobile',
				component: () => import('../views/Goods/detail_mob.vue'),
				meta: {
					title: $store.state.language == 'es-ES' ? 'Detalles de producto' : $store.state.language == 'en-GB' ? 'Goods details' : '商品详情'
				}
			},
			{
				path: '/GoodsList',
				component: () => import('../views/Goods/list.vue'),
				meta: {
					title: !$store.state.language || $store.state.language == 'es-ES' ? 'Lista de productos' : $store.state.language == 'en-GB' ? 'product list' : '商品列表'
				}
			},
			{
				path: '/Cart',
				component: () => import('../views/Basket/basket.vue'),
				meta: {
					title:!$store.state.language || $store.state.language == 'es-ES' ? 'Lista de productos' : $store.state.language == 'en-GB' ? 'cart' : '购物车'
				}
			},
			{
				path: '/Collect',
				component: () => import('../views/Like/list.vue'),
				meta: {
					title: !$store.state.language || $store.state.language == 'es-ES' ? 'Colección' : $store.state.language == 'en-GB' ? 'collect' : '收藏'
				}
			},
			{
				path: '/Search',
				component: () => import('../views/Goods/search.vue'),
				meta: {
					title: !$store.state.language || $store.state.language == 'es-ES' ? 'Buscar' : $store.state.language == 'en-GB' ? 'search' : '搜索'
				}
			},
			{
				path: '/Ensure',
				component: () => import('../views/Order/ensure.vue'),
				meta: {
					title: !$store.state.language || $store.state.language == 'es-ES' ? 'Confirmar pedido' : $store.state.language == 'en-GB' ? 'Confirm order' : '确认订单'
				}
			},
			{
				path: '/Mine',
				component: () => import('../views/Mine/Base.vue'),
				children: [{
						path: '/OrderList',
						component: () => import('../views/Order/list.vue'),
						meta: {
							title: !$store.state.language || $store.state.language == 'es-ES' ? 'Lista de pedidos' : $store.state.language == 'en-GB' ? 'Order list' : '订单列表'
						}
					},
					{
						name: 'OrderDetail',
						path: '/OrderDetail',
						component: () => import('../views/Order/detail.vue'),
						meta: {
							title:  !$store.state.language || $store.state.language == 'es-ES' ? 'Detalles del pedido' : $store.state.language == 'en-GB' ? 'Order details' : '订单详情'
						}
					},
					{
						path: '/Information',
						component: () => import('../views/Mine/information.vue'),
						meta: {
							title: !$store.state.language || $store.state.language == 'es-ES' ? 'Información del usuario' : $store.state.language == 'en-GB' ? 'User Information' : '用户信息'
						}
					},
					{
						path: '/Address',
						component: () => import('../views/Address/list.vue'),
						meta: {
							title: !$store.state.language || $store.state.language == 'es-ES' ? 'Gestión de direcciones' : $store.state.language == 'en-GB' ? 'Address Management' : '地址管理'
						}
					}
				]
			}
		]
	}
]

const router = new VueRouter({
	routes
})

export default router